// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"8a10a5e1","363":"8178199e","433":"e336a0be","453":"c2fb3fdd","525":"39632969","819":"33f83e30","967":"809a6f4e"}[chunkId] + ".chunk.js";
};